import { Injectable } from '@angular/core';
import { GiftCard, GiftCarFromNonce } from '../models/gift-card.model';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL } from '../enums/url.enum';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { dataToGiftCard } from '../dto/gift-card.dto';

@Injectable({
  providedIn: 'root'
})
export class GiftCardService {
  public giftCard: Subject<GiftCard> = new Subject<GiftCard>();

  constructor(
    private http: HttpClient,
  ) { }

  public getGiftCardFromNonce(giftCardNonce: GiftCarFromNonce): Observable<GiftCard> {
    return this.http.post(environment.apiUrl + URL.gift_card_form_nonce, giftCardNonce)
      .pipe(map((response: GiftCard) => {
        const giftCard = dataToGiftCard(response);
        this.setGiftCard(giftCard);
        return giftCard;
      }));
  }
  public get getGiftCard(): Observable<GiftCard> {
    return this.giftCard.asObservable();
  }
  public setGiftCard(giftCard: GiftCard): void {
    this.giftCard.next(giftCard);
  }
}
